<div class="detail-page-card">
    <div class="detail-page-card-title">
        {{ Label || ('detailOverview.controlOverviewLabel' | t) }}
    </div>
    <div class="detail-page-card-actions">
        @if (!HideOpenControlButton) {
            <button
                class="btn btn-raised"
                data-uiid="control-detail-overview-open-control-button"
                (click)="openControl()"
            >
                <i class="fas fa-external-link-alt"></i>
                <span>{{ 'detailOverview.openControlBtn' | t }}</span>
            </button>
        }
    </div>

    <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
        @if (overviewModel) {
            <div>
                @if (!HideControlDetails) {
                    <div class="row">
                        <div class="col left-block">
                            <div class="row">
                                <div class="col-3">
                                    <div class="form-group">
                                        <label>{{ 'detailOverview.identifierLabel' | t }}</label>
                                        <input
                                            data-uiid="control-identifier"
                                            type="text"
                                            class="form-control form-control-sm"
                                            disabled
                                            [value]="overviewModel.ControlIdentifier"
                                            inputTooltip
                                        />
                                    </div>
                                </div>

                                <div class="col-9">
                                    <div class="form-group">
                                        <label>{{ 'detailOverview.controlNameLabel' | t }}</label>
                                        <input
                                            data-uiid="control-name"
                                            type="text"
                                            class="form-control form-control-sm"
                                            disabled
                                            [value]="overviewModel.ControlName"
                                            inputTooltip
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{ 'detailOverview.descriptionLabel' | t }}</label>
                                <textarea
                                    data-uiid="control-description"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="overviewModel.ControlDescription"
                                    inputTooltip
                                ></textarea>
                            </div>
                        </div>

                        <div class="col right-block">
                            <div class="form-group">
                                <label>{{ 'detailOverview.controlFrequencyLabel' | t }}</label>
                                <input
                                    data-uiid="control-frequency"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="overviewModel.ControlFrequency"
                                    inputTooltip
                                />
                            </div>

                            <div class="form-group">
                                <label>{{ 'detailOverview.mitigatedRisksLabel' | t }}</label>
                                <textarea
                                    data-uiid="control-mitigatedrisks"
                                    type="date"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="overviewModel.ControlMitigatedRisks"
                                    inputTooltip
                                ></textarea>
                            </div>
                        </div>
                    </div>
                }
                @if (!HideControlDetails && (!HideDesignScore || !HideEffectivenessScore)) {
                    <div class="form-group-separator"></div>
                }

                @if (!HideDesignScore || !HideEffectivenessScore) {
                    <div class="row">
                        @if (!HideDesignScore) {
                            <div class="col" [class.left-block]="!HideEffectivenessScore">
                                <div class="row">
                                    <div class="col-6" [class.left-block]="HideEffectivenessScore">
                                        <div class="form-group">
                                            <label>{{ 'detailOverview.designScoreLabel' | t }}</label>
                                            <ng-select
                                                data-uiid="control-designscore"
                                                [items]="[
                                                    {
                                                        Id: 1,
                                                        Name: overviewModel.DesignScore,
                                                        Color: overviewModel.DesignScoreColor,
                                                    },
                                                ]"
                                                [ngModel]="1"
                                                bindLabel="Name"
                                                bindValue="Id"
                                                disabled
                                            >
                                                <ng-template
                                                    ng-label-tmp
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    <div
                                                        [style.background-color]="item.Color"
                                                        class="color-indicator"
                                                    ></div>
                                                    {{ item.Name }}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-6" [class.right-block]="HideEffectivenessScore">
                                        <div class="form-group">
                                            <label>{{ 'detailOverview.implementationScoreLabel' | t }}</label>
                                            <ng-select
                                                data-uiid="control-implementationscore"
                                                [items]="[
                                                    {
                                                        Id: 1,
                                                        Name: overviewModel.ImplementationScore,
                                                        Color: overviewModel.ImplementationScoreColor,
                                                    },
                                                ]"
                                                [ngModel]="1"
                                                bindLabel="Name"
                                                bindValue="Id"
                                                disabled
                                            >
                                                <ng-template
                                                    ng-label-tmp
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    <div
                                                        [style.background-color]="item.Color"
                                                        class="color-indicator"
                                                    ></div>
                                                    {{ item.Name }}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6" [class.left-block]="HideEffectivenessScore">
                                        <div class="form-group">
                                            <label>{{ 'detailOverview.dateTestedDiLabel' | t }}</label>
                                            <date-input
                                                data-uiid="control-datetesteddi"
                                                [(value)]="overviewModel.DIDateTested"
                                                [disabled]="true"
                                            ></date-input>
                                        </div>
                                    </div>

                                    <div class="col-6" [class.right-block]="HideEffectivenessScore">
                                        <div class="form-group">
                                            <label>{{ 'detailOverview.nextTestDateDiLabel' | t }}</label>
                                            <date-input
                                                data-uiid="control-nexttestdatedi"
                                                [(value)]="overviewModel.DINextDateTested"
                                                [disabled]="true"
                                            >
                                            </date-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        @if (!HideEffectivenessScore) {
                            <div class="col" [class.right-block]="!HideDesignScore">
                                <div class="row">
                                    <div class="col-6" [class.left-block]="HideDesignScore">
                                        <div class="form-group">
                                            <label>{{ 'detailOverview.effectivenessScoreLabel' | t }}</label>
                                            <ng-select
                                                data-uiid="control-effectivenessscore"
                                                [items]="[
                                                    {
                                                        Id: 1,
                                                        Name: overviewModel.EffectivenessScore,
                                                        Color: overviewModel.EffectivenessScoreColor,
                                                    },
                                                ]"
                                                [ngModel]="1"
                                                bindLabel="Name"
                                                bindValue="Id"
                                                disabled
                                            >
                                                <ng-template
                                                    ng-label-tmp
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    <div
                                                        [style.background-color]="item.Color"
                                                        class="color-indicator"
                                                    ></div>
                                                    {{ item.Name }}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-6" [class.right-block]="HideDesignScore">
                                        <div class="form-group">
                                            <label>{{ 'detailOverview.conclusionScoreLabel' | t }}</label>
                                            <ng-select
                                                data-uiid="control-conclusionscore"
                                                [items]="[
                                                    {
                                                        Id: 1,
                                                        Name: overviewModel.ConclusionScore,
                                                        Color: overviewModel.ConclusionScoreColor,
                                                    },
                                                ]"
                                                [ngModel]="1"
                                                bindLabel="Name"
                                                bindValue="Id"
                                                disabled
                                            >
                                                <ng-template
                                                    ng-label-tmp
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    <div
                                                        [style.background-color]="item.Color"
                                                        class="color-indicator"
                                                    ></div>
                                                    {{ item.Name }}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6" [class.left-block]="HideDesignScore">
                                        <div class="form-group">
                                            <label>{{ 'detailOverview.dateTestedEffectivenessLabel' | t }}</label>
                                            <date-input
                                                data-uiid="control-datetestedeffectiveness"
                                                [(value)]="overviewModel.EffectivenessDateTested"
                                                [disabled]="true"
                                            >
                                            </date-input>
                                        </div>
                                    </div>

                                    <div class="col-6" [class.right-block]="HideDesignScore">
                                        <div class="form-group">
                                            <label>{{ 'detailOverview.nextTestDateEffectivenessLabel' | t }}</label>
                                            <date-input
                                                data-uiid="control-nexttestdateeffectiveness"
                                                [(value)]="
                                                    overviewModel.EffectivenessNextDateTested
                                                "
                                                [disabled]="true"
                                            >
                                            </date-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        } @else {
            <div class="fancy-loader submodule"></div>
        }
    </div>
</div>
